import type { FaireProductEntity } from "../../entity_types/product";

export const p_phcdv8wv7g: FaireProductEntity = {
  token: "p_phcdv8wv7g",
  type: "product",
  name: "Toddler Vintage Inspired Basketball Crew",
  brandToken: "b_2f9md2aaq7",
  brandName: "Lucky Link",
  imageUrl:
    "https://cdn.faire.com/fastly/9880cabc6446148edcb0f30a4846e978bc7b3dea29ea264c0f3b039d210c5c92.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/950b1b44cd48f9373d4202bd77f9d5c236b81010c363398f40588dd12497e706.jpeg",
    "https://cdn.faire.com/fastly/2a9e8b4c2be199b9946bee488bbb4370051270117a35160376d46392c05a8fe9.jpeg",
    "https://cdn.faire.com/fastly/b2be5b173961386dfe3abf823e9819eee9d1f14a1e67d28901a716f177dda69e.jpeg",
    "https://cdn.faire.com/fastly/b4fb2c2a89b6f9f47d0852e1dddce1b3841b1eb3e00ca9f6fb82861de0add2d4.jpeg",
  ],
  priceDollars: 19.2,
  description:
    "Meet our Vintage-Inspired Basketball Crew. In Soft Brushed Terry Fleece, and Boasting a Washed-Black Acid Wash, this will be your go-to for a Casual, Cool Look. \n\n\n\nPRODUCT DETAILS:\n\n-True To Size, with a Perfectly Oversized Fit\n\n-Rib Collar, Bottom Band, and Cuff\n\n-100% Cotton\n\n-Made in China",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:41.740Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
